var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchAmazonElasticContainerService32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture/32/Arch_Amazon-Elastic-Container-Service_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8511B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture/32/Arch_Amazon-Elastic-Container-Service_32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture-BG/32/Compute",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Service/32/Amazon-Elastic-Container-Service",
    transform: "translate(4.000000, 4.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28,20.2493941 L24,17.8925474 L24,11.8250672 C24,11.6354584 23.888,11.4625509 23.713,11.3810093 L18,8.73631101 L18,4.28492611 L28,9.18233369 L28,20.2493941 Z M28.722,8.43863509 L17.722,3.05197797 C17.567,2.97534852 17.383,2.98419038 17.237,3.0735914 C17.09,3.16299242 17,3.32116346 17,3.49112364 L17,9.04774094 C17,9.2373497 17.111,9.4112396 17.287,9.49179876 L23,12.1364971 L23,18.1705748 C23,18.3434823 23.091,18.5026357 23.243,18.5910543 L28.243,21.5383407 C28.322,21.5854973 28.411,21.6090756 28.5,21.6090756 C28.585,21.6090756 28.67,21.5874622 28.746,21.5452177 C28.903,21.4577816 29,21.2946984 29,21.1178612 L29,8.87778076 C29,8.69210172 28.892,8.52115911 28.722,8.43863509 L28.722,8.43863509 Z M15.995,28.9517485 L5,23.3165369 L5,9.16857969 L14,4.32029355 L14,8.76185416 L9.254,11.3977106 C9.096,11.4851468 9,11.64823 9,11.8250672 L9,20.6669264 C9,20.8457284 9.099,21.0107765 9.258,21.0972302 L15.758,24.6123605 C15.909,24.693902 16.091,24.693902 16.24,24.6133429 L22.49,21.2416472 L26.036,23.5719684 L15.995,28.9517485 Z M22.794,20.2592184 C22.638,20.1570458 22.439,20.1491864 22.275,20.2366226 L16,23.6220722 L10,20.3771099 L10,12.1119364 L14.746,9.47509747 C14.903,9.38864374 15,9.22457813 15,9.04774094 L15,3.49112364 C15,3.31723374 14.907,3.15709785 14.755,3.06867926 C14.603,2.98026067 14.415,2.97731338 14.259,3.0598374 L4.259,8.44747695 C4.099,8.53393068 4,8.69897872 4,8.87778076 L4,23.6142128 C4,23.797927 4.103,23.9649399 4.268,24.0504112 L15.768,29.944984 C15.84,29.9813339 15.921,30 16,30 C16.082,30 16.165,29.9803514 16.239,29.9400718 L27.239,24.045499 C27.392,23.962975 27.491,23.8087337 27.499,23.6368087 C27.507,23.4648836 27.424,23.3018004 27.278,23.2065048 L22.794,20.2592184 Z",
    id: "Amazon-Elastic-Container-Service_Icon_32_Squid"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchAmazonElasticContainerService32);
export default __webpack_public_path__ + "static/media/Arch_Amazon-Elastic-Container-Service_32.5263175cb7b9a65fa7f9c4b0d24432a5.svg";
export { ForwardRef as ReactComponent };